(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-letter"] && !window.DesignMode) return;
  try {
    

var str="collection-title";
var newStr = str.replace(/-/g, "");


  } catch(e) { console.error(e); }
})();
})();
